'use strict';

(function () {
  'use strict';

  angular.module('msCore').factory('NotifyingSvc', notifyingSvc);

  notifyingSvc.$inject = ['$rootScope'];

  function notifyingSvc($rootScope) {
    var _EVENTS = {
      OPTIN_UPDATE: 'optin-updated',
      ACTIVITY_STARTED: 'activity-started',
      ACTIVITY_COMPLETE: 'activity-complete',
      PAGE_TITLE: 'page-title',
      ACTIVITY_PAGE: 'activity-page',
      SEARCH_RESULTS: 'search-results',
      PROFILE_SAVED: 'profile-saved',
      ALERTS_UPDATED: 'alerts-updated',
      GOALS_UPDATED: 'goals-updated',
      USER_UPDATED: 'user-updated',
      USER_SIGNUP_COMPLETE: 'user-signup-complete',
      USER_LOGIN_COMPLETE: 'user-login-complete',
      REFRESH_TRACKER: 'refresh-tracker',
      OPEN_MODAL: 'open-modal',
      PRINT_HTTP_COMPLETE: 'print-http-complete',
      FOCUS_UPDATED: 'focus-updated',
      ENTRY_CREATED: 'sleep-entry-created',
      USER_OAUTH_LOGIN: 'user-oauth-login',
      USER_COACHING_ENABLEMENT_UPDATED: 'user-coaching-enablement-updated',
      GET_AGREEMENTS: 'get-agreements'
    };

    return {
      EVENTS: _EVENTS,
      subscribe: _subscribe,
      notifyEvent: _notifyEvent
    };

    /**
     * Subscribe to an event listener
     * @param event The name of the event to subscribe to.
     * @param callback The function to execute when the event is received
     * @param scope The scope from the calling context. This is used to destroy the handler and is optional.
     * @private
     */
    function _subscribe(event, callback, scope) {
      var _handler = $rootScope.$on(event, callback);
      if (scope) {
        scope.$on('$destroy', _handler);
      }
    }
    /**
     * Generate a signal update event
     * @private
     */
    function _notifyEvent(signal, args) {
      $rootScope.$emit(signal, args);
    }
  }
})();